import { Component, OnInit, Inject } from '@angular/core';
import { ItemType, ItemCoverageType } from '../../../shared/models/item.type.interface';
import { RValue } from '../../../shared/models/r.value.interface';
import { Vendor } from '../../../shared/models/vendor.interface';
import { Warehouse } from '../../../shared/models/warehouse.interface';
import { AdminService } from '../../services/admin.service';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs';
import { ItemUsage } from '../../../shared/models/item.usage.interface';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IdiItemSource } from '../../../shared/models/idiitem.source.interface';
import { ItemDialogData } from '../../item/item-list/item-list.component';

export interface ItemCoverageData {
  item_ID: number;
  itemUsages: ItemUsage[];
  coveragePerSet: number;
  columnEntries: number;
}

@Component({
  selector: 'app-item-source-edit',
  templateUrl: './item-source-edit.component.html',
  styleUrls: ['./item-source-edit.component.scss']
})

export class ItemSourceEditComponent implements OnInit {
  coverageEnum = ItemCoverageType;
  item: IdiItemSource;
  itemTypes: ItemType[];

  rValues: RValue[];
  vendors: Vendor[];
  warehouses: Warehouse[];
  itemUsages: ItemUsage[] = [];
  itemType: ItemType;
  canDeleteItem: boolean = false;
  showItemCoverage: boolean = false;
  itemTypeRequired: boolean = true;
  showAeroBarrier: boolean = false;
  isIDIAdmin: boolean = false;

  isRequesting: boolean;
  errors: string;

  constructor(private adminService: AdminService, public itemDialogRef: MatDialogRef<ItemSourceEditComponent>, @Inject(MAT_DIALOG_DATA) public data: ItemDialogData) { }

  ngOnInit() {
    let itemId: string = this.data.id;
    this.rValues = this.data.rValues;
    this.isIDIAdmin = (AdminService._authNavStatusSource.value == 'IDI');    

    if (itemId == null) {
      this.item = {} as IdiItemSource;
      this.item.item_isActive = true;
    }
    else {
      this.adminService.getIDIItem(itemId)
        .subscribe({
          next: (data) => {
            this.item = data;
            this.itemTypeRequired = !data.itemType?.itemType_IsAccessory;
            this.showAeroBarrier = data.itemType?.itemCoverageType_ID !== null && data.itemType?.itemCoverageType_ID == this.coverageEnum.AeroBarrier;
            if (data.itemType?.itemType_IsUsage) {
            }
          }
        })

      this.adminService.checkCanDeleteItem(itemId)
        .subscribe({
          next: (data) => {
            this.canDeleteItem = data;
          }
        })
    }

    this.adminService.getItemTypes(null)
      .subscribe({
        next: (data) => {
          this.itemTypes = data;
        }
      })
  }

  saveItemSource(form: NgForm) {

    console.log('in item onSubmit: ', this.item)
    this.errors = '';
    let isNewItem = false;

    if (form.valid) {
      this.isRequesting = true;
      if (this.item.item_ID == null) {
        this.item.itemType = null;
        isNewItem = true;
      }

      if (!isNewItem && this.item.itemType_ID !== this.item.itemType.itemType_ID) {
        this.item.itemType = null;
      }

      this.adminService.saveIDIItem(this.item)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe(
          result => {
            if (result) {
              this.itemDialogRef.close();
            }
            else {
               (error: string) =>this.errors = error;
            }
          });
    }
  }

  // this gets called on price change for aerobarrier...
  // Doing this because item cost is shown in some interfaces but want to keep aerobarrier
  //base price in its own field
  populateCost() {
    const selectedItemType = this.itemTypes.find(it => it.itemType_ID === this.item.itemType_ID);

    if (this.item.item_Cost_SqrFt && selectedItemType.itemCoverageType_ID === this.coverageEnum.AeroBarrier) {
      this.item.item_SqrFtPerUnit = 1;
      this.item.item_Cost = this.item.item_Cost_SqrFt;
    }
  }

  deleteItem(itemId) {
    var proceed = confirm($localize`Are you sure?`);
    if (!proceed) return;

    console.log('in item delete: ', this.item)
    this.errors = '';
    this.isRequesting = true;
    if (itemId != null) {
      this.adminService.deleteIDIItem(itemId)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe({
          next: (result) => {
          if(result) {
            this.itemDialogRef.close();
          }
        },
          error: (error: string) => {
            this.errors = error;
          }
        });
    }
  }

  onItemTypeChange(itemTypeId: number) {
    this.adminService.getItemType(itemTypeId)
      .subscribe({
        next: (data) => {
          if (data.itemType_IsUsage) {
            this.showItemCoverage = data.itemType_IsUsage;
            this.showAeroBarrier = false;
            this.itemTypeRequired = !data.itemType_IsAccessory;
          }
          else if (data.itemCoverageType_ID == this.coverageEnum.AeroBarrier) {
            this.showItemCoverage = false;
            this.itemUsages = null;
            this.showAeroBarrier = data.itemCoverageType_ID == this.coverageEnum.AeroBarrier;
            this.itemTypeRequired = !data.itemType_IsAccessory;
          }
          else {
            this.showAeroBarrier = false;
            this.showItemCoverage = false;
            this.itemTypeRequired = !data.itemType_IsAccessory;
          }
        }
      });
  }

  onNoClick(): void {
    this.itemDialogRef.close();
  }
}
